export enum ResidentpageState {
    SearchResidentByEmail = 'searchResidentByEmail',
    SearchPropertiesByAddress = 'searchPropertiesByAddress',
    SelectProperty = 'selectProperty',
    SearchResidentsByPuuidAndName = 'searchResidentsByPuuidAndName',
    SelectResident = 'selectResident',
    SearchSpecialCode = 'searchSpecialCode',
}
